// ... existing imports ...

import React, { useCallback, useEffect, useState } from 'react';
import { UserLiteData } from '../../../api/ApiTypes';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { useSubmitter } from '../../../platform/Hook';
import { Colors, Spinner } from '../../../ui';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { SelectUserView } from '../../common/SelectUserView';
import { useResolve } from '../../Container';
import { Flexer, Title } from '../../dashboard/elements/LayoutElements';
import { toTaskDueDate } from '../../dashboard/tasks/TaskActions';
import { SelectDueDateView } from './SelectDueDateView';
import { tasksAssign } from './TaskCommands';

const CreatingView = () =>
    <Flexer width="18" height="6" flex="row" center gap="1.75" color={Colors.primaryText}>
        <Spinner size={1.75} stroke={4} />
        <Title flush size="lg">
            Assigning task...
        </Title>
    </Flexer>;


export const AssignmentCreateView = ({ targetIds, onClose }: { targetIds: string[], onClose: () => void }) => {

    const dispatch = useResolve(CommandDispatcher);

    const [user, setUser] = useState<UserLiteData>(null);
    const [date, setDate] = useState<Date | 'none'>(null);
    const [submitted, setSubmitted] = useState(false);

    const [onSubmit] = useSubmitter(async () => {
        await dispatch(tasksAssign, [user.id, date === 'none' ? null : toTaskDueDate(date), targetIds]);
        onClose();
    }, [user, date, targetIds]);

    useEffect(() => {
        if (user && date && !submitted) {
            setSubmitted(true);
            onSubmit();
        }
    }, [user, date, submitted]);

    return <>
        {!user && <SelectUserView allowKeyboard allowSearch title="Assign Action To:" onSelect={setUser} />}
        {!!user && !date && <SelectDueDateView onSelect={x => setDate(x || 'none')} />}
        {!!submitted && <CreatingView />}
    </>;
};

export const AssignmentCreateWidget = ({ widget }: { widget: PopoutWidget }) => {

    const targetIds = widget.value as string[];
    const onClose = useCallback(() => widget.update({ open: false }), []);
    return <AssignmentCreateView targetIds={targetIds} onClose={onClose} />;
};
